export default __webpack_public_path__ + "static/2.2_IT-e5be853632d93138eb2bc841d24c7fb8.webp";